import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Clock, Utensils, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { data } from '../data';

const Bryllup = () => {
  const service = data.services[0]; // Bryllup data

  return (
    <div className="pt-0">
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src={service.image} 
            className="w-full h-full object-cover" 
            alt="Bryllup på GuldBoSund Konference & Event" 
          />
          <div className="absolute inset-0 bg-[#081f32]/40" />
        </div>
        
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mt-20">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
            className="text-5xl md:text-7xl font-light mb-6 uppercase tracking-wider"
          >
            Bryllup
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.2 }}
            className="text-xl md:text-2xl font-light"
          >
            Den mest romantiske ramme for jeres store dag
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-4xl font-light text-gray-900 mb-8 uppercase tracking-wider">Kærlighed ved Guldborgsund</h2>
              <div className="prose prose-lg text-gray-600 space-y-6">
                <p>
                  Forestil jer at sige ja til hinanden med udsigt over det glitrende vand, omgivet af dem I holder af. Hos GuldBoSund Konference & Event skaber vi den perfekte kulisse for jeres drømmebryllup.
                </p>
                <p>
                  Vores lyse og arkitektonisk smukke lokaler kan rumme både intime selskaber og store bryllupsfester. Vi tager hånd om alle detaljer, så I kan fokusere på hinanden og jeres gæster. Fra den første velkomstdrink på terrassen til natmaden og den efterfølgende overnatning.
                </p>
              </div>

              <div className="mt-10">
                <p className="text-xs font-medium uppercase tracking-[0.24em] text-[#081f32]/60 mb-3">Personligt tilbud</p>
                <h3 className="text-2xl md:text-3xl font-medium leading-snug text-[#081f32]">
                  Vi skræddersyer og laver gerne et tilbud helt efter jeres ønsker og behov.
                </h3>
              </div>

              <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
                {service.features.map((feature, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <CheckCircle2 className="text-[#dab256] flex-shrink-0" size={20} />
                    <span className="text-gray-700 font-light">{feature}</span>
                  </div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="bg-[#081f32] text-white p-10 rounded-3xl shadow-2xl relative overflow-hidden"
            >
              <div className="relative z-10">
                <h3 className="text-2xl font-light mb-6 uppercase tracking-widest">Bryllupspakke</h3>
                <div className="flex items-baseline gap-2 mb-8">
                  <span className="text-5xl font-light text-[#dab256]">{service.price}</span>
                  <span className="text-gray-400 font-light">kr. pr. kuvert</span>
                </div>
                
                <p className="text-stone-300 mb-8 font-light leading-relaxed">
                  Vores bryllupspakke er sammensat for at give jer en komplet og bekymringsfri oplevelse. Vi sørger for alt det praktiske, mens I skaber minder.
                </p>

                <ul className="space-y-4 mb-10 border-t border-white/10 pt-8">
                  <li className="flex justify-between items-center text-sm">
                    <span className="text-gray-400 uppercase tracking-widest text-[10px]">Varighed</span>
                    <span className="font-light">8 timer (mulighed for tilkøb)</span>
                  </li>
                  <li className="flex justify-between items-center text-sm">
                    <span className="text-gray-400 uppercase tracking-widest text-[10px]">Forplejning</span>
                    <span className="font-light">Velkomst, 3 retter & vin</span>
                  </li>
                  <li className="flex justify-between items-center text-sm">
                    <span className="text-gray-400 uppercase tracking-widest text-[10px]">Lokaler</span>
                    <span className="font-light">Eget lokale med udsigt</span>
                  </li>
                </ul>

                <Link to="/kontakt" className="block w-full bg-[#dab256] text-[#081f32] py-4 rounded-xl text-center text-xs font-light uppercase tracking-widest hover:bg-[#c4a04a] transition-colors shadow-lg">
                  Book en fremvisning
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Bryllup;
